export default __webpack_public_path__ + "static/media/member-onboarding-image.c57c1370.png";